module.exports = __webpack_public_path__ + "img/070.332248f5.png";